import { PATH } from '#const/path';
import { DashboardChartModal } from '#pages/DashboardCustomer/DashboardChartModal';
import { IRegisteredLecture } from '#types/registeredLectures';
import { useState } from 'react';
import TagManager from 'react-gtm-module';
import { useNavigate } from 'react-router';

interface ItemProps extends IRegisteredLecture {
  isGroup: boolean;
  previousRegisteredLectureId?: string;
}

const Item = ({
  id,
  round,
  taughtAt,
  endedAt,
  exerciseRecordStatus,
  isGroup,
  previousRegisteredLectureId
}: ItemProps) => {
  const getYearMonthDay = (dateStr: string) => {
    // 날짜 객체 생성
    const date = new Date(dateStr);

    // 연도, 월, 일, 시간 추출
    const year = date.getUTCFullYear().toString().slice(2); // 연도의 마지막 두 자리
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // 월 (0부터 시작하므로 +1)
    const day = date.getUTCDate().toString().padStart(2, '0'); // 일

    return `${year}.${month}.${day}`;
  };

  const getTime = (dateStr: string) => {
    // 날짜 객체 생성
    const date = new Date(dateStr);

    // 시간 추출
    const hour = date.getUTCHours().toString().padStart(2, '0'); // 시
    const minute = date.getUTCMinutes().toString().padStart(2, '0'); // 분

    return `${hour}:${minute}`;
  };

  const getButtonText = () => {
    switch (exerciseRecordStatus) {
      case 1:
        return '작성';
      case 2:
        return '수정';
      case 3:
        return '보기';
      default:
        return '';
    }
  };

  const getBackgroundColor = () => {
    switch (exerciseRecordStatus) {
      case 1:
      case 2:
        return '#7750e9';
      case 3:
        return '#2e2a3a';
      default:
        return '';
    }
  };

  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  const onClick = () => {
    if (isGroup) {
      return;
    }

    if (exerciseRecordStatus === 1) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'customer_exercisechart_fill_click',
          category: '회원관리',
          action: 'customer_exercisechart_fill_click',
          value: 2
        }
      });
      setIsOpen(true);
    }

    if (exerciseRecordStatus === 2) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'customer_exercisechart_edit_click',
          category: '회원관리',
          action: 'customer_exercisechart_edit_click',
          value: 2
        }
      });
      navigate(`${PATH.DASHBOARD_CHART_FORM_EDIT}?registered-lecture-id=${id}`);
    }

    if (exerciseRecordStatus === 3) {
      navigate(`${PATH.DASHBOARD_CHART}?registered-lecture-id=${id}`);
    }
  };

  return (
    <>
      <div className="w-full h-[45px] justify-between items-center inline-flex">
        <div className="flex-col justify-center items-start gap-8 inline-flex">
          <div className="flex-col justify-start items-start gap-2 flex">
            <div className="text-center text-[#bcb8c3] text-lg font-medium font-['Pretendard Variable'] leading-snug">
              {round}회차
            </div>
            <div className="justify-end items-center gap-4 inline-flex">
              <div className="text-center text-[#938f9e] text-sm font-normal font-['Pretendard Variable'] leading-tight">
                {getYearMonthDay(taughtAt)}
              </div>
              <div className="text-center text-[#938f9e] text-sm font-normal font-['Pretendard Variable'] leading-tight">
                {getTime(taughtAt)} - {getTime(endedAt)}
              </div>
            </div>
          </div>
        </div>
        <div
          onClick={onClick}
          style={{
            backgroundColor: isGroup ? '#2e2a3a' : getBackgroundColor()
          }}
          className="h-[45px] px-40 py-12 bg-[#2e2a3a] rounded-lg justify-center items-center gap-10 inline-flex"
        >
          <div className="text-[#bcb8c3] text-base font-medium font-['Pretendard Variable'] leading-[21px]">
            {isGroup ? '기능 준비중' : getButtonText()}
          </div>
        </div>
      </div>
      {isOpen && (
        <DashboardChartModal
          onClose={() => setIsOpen(false)}
          registeredLectureId={id}
          previousRegisteredLectureId={previousRegisteredLectureId}
        />
      )}
    </>
  );
};

export default Item;
